import {setPricingNotification} from "./pricingActions";
import {getApiConfig} from "../../utilities";
import {
  getCatalogsToUpdate,
  saveNewCatalogs
} from "./PricingSidebar/pricingCatalogAsyncActions";
import {errorBox_Show} from "../../actions/A_Popups";
import PS from "../ProjectScope/ProjectScopeActionsNew";
import {featureIsEditedAndCanBeSaved} from "./PricingFeatures/pricingFeaturesFunctions";
import {postSaveFeatures} from "./PricingFeatures/pricingFeaturesAsyncActions";

let notificationTimer = null;

export const getToPostFeatureGroups = (store) => {
  if (!Object.keys(store.pricingState.pricingCustomGroupNames).length) {
    return []
  }
  const {featuresGroups} = store.projectScopeNew;
  let toPostFeatureGroups = [];
  Object.keys(store.pricingState.pricingCustomGroupNames).forEach(groupName => {
    const featureGroup = featuresGroups.find((fg) => fg.groupName === groupName);
    if (!featureGroup) {
      console.log("not possible, featureGroup not found?");
      return
    }
    const newName = store.pricingState.pricingCustomGroupNames[groupName];
    if (((!featureGroup.customDisplayName && (newName !== groupName)) ||
      (featureGroup.customDisplayName && (featureGroup.customDisplayName !== newName)))) {
      toPostFeatureGroups.push({...featureGroup, customDisplayName: newName});
    }
  });
  return toPostFeatureGroups
}

const savePricingCustomGroupNames = async (dispatch, store) => {
  const toPostFeatureGroups = getToPostFeatureGroups(store);
  if (toPostFeatureGroups.length) {
    const postResponse = await getApiConfig('ProjectScope').post(toPostFeatureGroups, `/feature-groups-save`)
    if (!postResponse || !postResponse.success) {
      return Promise.reject(postResponse);
    }
    const {featuresGroups} = store.projectScopeNew;
    const newFeatureGroups = featuresGroups.map(fg => {
      const updatedFg = toPostFeatureGroups.find((updatedFg) => updatedFg.groupName === fg.groupName);
      return updatedFg || fg
    });
    dispatch(PS.updateFeatureGroups(newFeatureGroups));
  }
  return Promise.resolve();
}

const getFeaturesToUpdateLength = (pricingEditedFeatures) => {
  return Object.keys(pricingEditedFeatures).reduce((total, featureDefinitionId) => {
    if (featureIsEditedAndCanBeSaved(pricingEditedFeatures[featureDefinitionId])) {
      total = total + 1
    }
    return total
  }, 0)
}

export const getCurrentUpdateCount = (store) => {
  const {pricingCatalogsToSave, pricingCatalogsToUpdate} = getCatalogsToUpdate(store);
  const {pricingEditedFeatures} = store.pricingState;
  const featuresToUpdateLength = getFeaturesToUpdateLength(pricingEditedFeatures)
  return getToPostFeatureGroups(store).length
    + pricingCatalogsToSave.length
    + pricingCatalogsToUpdate.length
    + featuresToUpdateLength;
}

export const savePricingPageChanges = () => {
  return async (dispatch, getState) => {

    clearTimeout(notificationTimer);

    const store = getState();
    let tasksCount = getCurrentUpdateCount(store);
    if (!tasksCount) {
      return
    }

    dispatch(setPricingNotification(
      true,
      "pending",
      `Your price updates have been scheduled, there ${tasksCount === 1 ? "is" : "are"} <span class="bold">${tasksCount}</span> ${tasksCount === 1 ? "update" : "updates"} to complete.`
    ));
    // const {auth, asCustomer} = getState();
    // fabricatorId =  asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    try {

      await savePricingCustomGroupNames(dispatch, store);
      await saveNewCatalogs(dispatch, store);
      await postSaveFeatures(dispatch, store);

      dispatch(setPricingNotification(true,"success","Your updates were successfully saved."));
      notificationTimer = setTimeout(() => {
        dispatch(setPricingNotification(false));
      }, 1500);

    } catch (response) {
      console.log("error", response);
      dispatch(errorBox_Show({
        // title: intl.formatMessage({id: "messageBox.errorTitle"}),
        title: "Error",
        text: response.error || response.__error__ || response + "",
        // rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
        rightButtonText: "Ok",
        isRightButtonVisible: true
      }));
      dispatch(setPricingNotification(true,"error","An error occurred"));
    }
  }
}
